import React from 'react';
import PropTypes from 'prop-types';

class AccountMyProfile extends React.Component {
  static propTypes = {
    fullName: PropTypes.string,
    position: PropTypes.string,
    email: PropTypes.string,
    telephone: PropTypes.string,
  };

  render() {
    return (
      <div>
        <label className="section-header">User Information</label>
        <div className="row">
          <div className="form-group col-sm-3">
            <label>Full Name</label>
            <div>{this.props.fullName}</div>
          </div>
          <div className="form-group col-sm-3">
            <label>Position</label>
            <div>{this.props.position}</div>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-3">
            <label>Email</label>
            <div>{this.props.email}</div>
          </div>
          <div className="form-group col-sm-3">
            <label>Telephone</label>
            <div>{this.props.telephone}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountMyProfile;



// WEBPACK FOOTER //
// ./src/component/account/AccountMyProfile/index.js